const locales = {
  en: [
    { key: "per", value: "per" },
    { key: "provinces", value: "Provinces" },
    { key: "buletin", value: "Buletin" },
    { key: "staff", value: "Staff" },
    { key: "accessAndInfrastructure", value: "Access And Infrastructure" },
    { key: "services", value: "Services" },
    {
      key: "noOfFacilitiesByOwnershipTypes",
      value: "Number of facilities by ownership types",
    },
    {
      key: "noOfFacilitiesByCategories",
      value: "Number of facilities by categories",
    },
    { key: "noOfFacilitiesByTypes", value: "Number of facilities by types" },
    { key: "noOfFacilitiesByStatus", value: "Number of facilities by status" },
    { key: "Key Indicators", value: "Key indicators" },
    {
      key: "Status of Key Nutrition Indicators",
      value: "Status of Key Nutrition Indicators",
    },
    {
      key: "topSectionWidget1Title",
      value: "Total Active service delivery units",
    },
    {
      key: "topSectionWidget2Title",
      value: "Health center with all equipment for EHS",
    },
    {
      key: "topSectionWidget3Title",
      value: "Health center with 80% essential drugs for EHS",
    },
    { key: "topSectionWidget4Title", value: "Total administrative units" },
    { key: "topSectionWidget5Title", value: "Total departments/offices" },
    { key: "topSectionWidget6Title", value: "Hospital to population ratio" },
    {
      key: "topSectionWidget7Title",
      value: "Health centre ratio to population",
    },
    { key: "topSectionWidget8Title", value: "Doctor to population ratio" },
    { key: "topSectionWidget9Title", value: "Nurse to population ratio" },
    { key: "serviceDeliUnitsWidget1Title", value: "By Ownership" },
    { key: "serviceDeliUnitsWidget2Title", value: "By Location" },
    {
      key: "serviceDeliUnitsWidget3Title",
      value: "Health Centers with adequate (>80%) human resource management",
    },
    {
      key: "serviceDeliUnitsWidget4Title",
      value: "Health Centers with adequate (>80%) infrastructure",
    },
    { key: "serviceDeliUnitsWidget5Title", value: "Organisation Unit Type" },
    {
      key: "serviceDeliUnitsWidget7ChartTitle",
      value: "Hospital ratio to population",
    },
    {
      key: "serviceDeliUnitsWidget7ChartTitle2",
      value: "Health facility ratio to population",
    },
    {
      key: "serviceDeliUnitsWidget6Title",
      value: "Hospital and Health center and  to population ratio (10,000)",
    },
    {
      key: "serviceDeliUnitsWidget7Title",
      value: "Health centers with equipment of Essential Health Services (EHS)",
    },
    {
      key: "serviceDeliUnitsWidget8ChartTitle",
      value: "HC without adequate equipment for EHS",
    },
    {
      key: "serviceDeliUnitsWidget8ChartTitle2",
      value: "HC with all equipment for EHS",
    },
    {
      key: "serviceDeliUnitsWidget8ChartTitle3",
      value: "QPS Assessment not done",
    },
    {
      key: "accessAndInfrastructureWidget1Title",
      value: "Number of Facilities by Type of Road access by province",
    },
    {
      key: "accessAndInfrastructureWidget1ChartTitle",
      value: "Number of Facilities by Type of Road access",
    },
    {
      key: "accessAndInfrastructureWidget2Title",
      value: "Number of Facilities by electricity source by province",
    },
    {
      key: "accessAndInfrastructureWidget2ChartTitle",
      value: "Number of Facilities by electricity source",
    },
    {
      key: "accessAndInfrastructureWidget3Title",
      value: "Total bed, fridge, bike, car, ambulance",
    },
    {
      key: "staffWidget1Title",
      value:
        "Doc, midwives, nurse, (Staff ->; total, regular, volunteer, contract)",
    },
    {
      key: "staffWidget2Title",
      value: "Doc ratio to population, nurse ratio to population",
    },
    {
      key: "servicesWidget1Title",
      value: "Total facility providing Advance surgery, Basic surgery",
    },
    {
      key: "servicesWidget2Title",
      value: "Total health centre, Health centre",
    },
    { key: "servicesWidget1ChartTitle", value: "" },
    { key: "Total Bed", value: "Total Bed" },
    { key: "Vaccine Fridge Total", value: "Vaccine Fridge Total" },
    { key: "Number of Bike", value: "Number of Bike" },
    { key: "Number of Car", value: "Number of Car" },
    { key: "Number of Ambulance", value: "Number of Ambulance" },
    { key: "OU_Facility Type", value: "OU_Facility Type" },
  ],
  lo: [
    {
      key: "Status of Key Nutrition Indicators",
      value: "ຂໍ້ມູນທີ່ສໍາຄັນຂອງຕົວຊີ້ວັດໂພຊະນາການ",
    },
    {
      key: "The scorecard excluded data from 4 provinces namely Phongsaly, Oudomxay, Savannakhet and Sekong as the roll out of revised nutrition data collection tools is not completed in these provinces.",
      value:
        "ຕາຕະລາງຄະແນນນີ້ບໍ່ໄດ້ລວມຂໍ້ມູນຈາກ 4 ແຂວງຄື: ຜົ້ງສາລີ, ອຸດົມໄຊ, ສະຫວັນນະເຂດ ແລະ ເຊກອງ ເນື່ອງຈາກການເກັບກຳຂໍ້ມູນດ້ານໂພຊະນາການສະບັບປັບປຸງຍັງບໍ່ສຳເລັດໃນແຂວງເຫຼົ່ານີ້.",
    },
    {
      key: "Pregnant women accessed Ante-Natal Care (ANC)",
      value: "ເປີເຊັນແມ່ຍິງຖືພາທີ່ໄດ້ເຂົ້າເຖິງການກວດທ້ອງກ່ອນເກິດ (ANC)",
    },
    {
      key: "Teenage pregnancies",
      value: "ການຖືພາໃນໄວໜຸ່ມ",
    },
    {
      key: "ANC IFA supplementation",
      value: "ເປີເຊັນແມ່ຍິງຖືພາທີ່ໄດ້ກິນຢາທາດເຫຼັກ ແລະ ໂຟລິກອາຊິດ",
    },
    {
      key: "Total/ Lao PDR",
      value: "ລວມທັງໝົດ",
    },
    {
      key: "Exclusive breastfeeding until discharge",
      value:
        "ເປີເຊັນຂອງເດັກເກີດໃໝ່ ທີ່ກິນນົມແມ່ພຽງຢ່າງດຽວຕັ້ງແຕ່ເກີດຈົນອອກໂຮງໝໍ",
    },
    {
      key: "Children under 5 accessed growth monitoring",
      value: "ເປີເຊັນເດັກນ້ອຍລຸ່ມ 5 ປີ ທີ່ໄດ້ຮັບການຕິດຕາມການຈະເລິນເຕີບໂຕ",
    },
    {
      key: "Early initiation of breastfeeding under 90 mts",
      value: "ເປີເຊັນຂອງເດັກນ້ອຍທີ່ໄດ້ດູດນົມແມ່ພາຍໃນ 90 ນາທີຫຼັງເກີດ",
    },
    {
      key: "Exclusive breastfeeding under 6 months",
      value:
        "ເປີເຊັນຂອງເດັກເກີດໃໝ່ ທີ່ກິນນົມແມ່ພຽງຢ່າງດຽວຕັ້ງແຕ່ເກີດຈົນອອກໂຮງໝໍ",
    },
    {
      key: "Institutional low birth weight rate",
      value: "ອັດຕາຂອງເດັກເກີດມີນໍ້າໜັກຕໍ່າໃນສະຖານທີ່ບໍລິການ",
    },
    {
      key: "Institutional over birth weight rate",
      value: "ອັດຕາຂອງເດັກເກີດມີນໍ້າໜັກເກິນໃນສະຖານທີ່ລິການ",
    },
    {
      key: "Children admitted for SAM treatment",
      value: "ຈໍານວນເດັກນ້ອຍທີ່ເປັນ SAM ທີ້ໄດ້ຮັບການປິ່ນປົວ",
    },
    {
      key: "Vitamin-A supplementation",
      value: "ເປີເຊັນຂອງເດັກນ້ອຍລຸ່ມ 5 ປິ ທີ່ໄດ້ຮັບຢາວິຕາມິນ ອາ",
    },
    {
      key: "Deworming",
      value: "ເປີເຊັນຂອງເດັກນ້ອຍລຸ່ມ 5 ປິ ທີ່ໄດ້ຮັບຢາຂ້າແມ່ທ້ອງ",
    },
    {
      key: "JAN-JUN 2024 Nutrition Scorecard - Key Indicators",
      value: "ຕາຕະລາງຄະແນນໂພຊະນາການ ມັງກອນ-ມິຖຸນາ 2024- ຕົວຊີ້ວັດທີ່ສໍາຄັນ",
    },
    {
      key: "JAN-JUN 2024 Nutrition Scorecard - Data Quality",
      value: "ຕາຕະລາງຄະແນນໂພຊະນາການ ມັງກອນ-ມິຖຸນາ 2024- ຄຸນນະພາບຂໍ້ມູນ",
    },
    { key: "Good", value: "ສູງ" },
    { key: "Average", value: "ສະເລ່ຍ" },
    { key: "Poor", value: "ຕ່ຳ" },
    { key: "Not Reported", value: "ບໍ່ໄດ້ລາຍງານ NR" },

    { key: "Growth Monitoring", value: "ການຕິ ຕິດຕາມການເຕີ ຕີບໂຕຂອງເດັ ດັກ" },
    {
      key: "Maternal, Infant and Young Child Nutrition",
      value: "ໂພຊະນາການຂອງແມ່, ເດັກ ແລະເດັກອ່ອນ",
    },
    {
      key: "Micronutrient supplementation",
      value: "ການເສີມ",
    },
    { key: "IMAM", value: "IMAM" },
    { key: "Key Indicators", value: "ຕົວຊີ້ວັດທີ່ສໍາຄັນ" },
    {
      key: "Children assessed for growth monitoring",
      value: "ເດັກນ້ອຍທີ່ໄດ້ຮັບການປະເມີນ",
    },
    {
      key: "Underweight among children under five years of age",
      value: "ນໍ້າໜັກ ທຽບໃສ່ ອາຍຸ",
    },
    {
      key: "Institutional Wasting",
      value: "ເດັກຈ່ອຍຜອມກວ່າມາດຕະຖານ ໃນສະຖານທີ່ລິການ",
    },
    { key: "ANC coverage", value: "ANC ອັດຕາການປົກຄຸມ" },
    {
      key: "Pregnant women who received IFA tablets during ANC",
      value: "ແມ່ຍິງຖືພາ ທີ່ໄດ້ຮັບຢາທາດເຫຼັກ - ອາຊິດໂຟລິກ ໃນຕອນກວດກ່ອນເກີດ",
    },
    {
      key: "Pregnant women identified as having anaemia",
      value: "ແມ່ຍິງຖືພາທີ່ເປັນພາວະເລືອດຈາງ (Hb<11 g/dl)",
    },
    { key: "Low birth weight", value: "ນໍ້າໜັກເກີດຕໍ່າກວ່າມາດຕະຖານ" },
    {
      key: "Early initiation of breastfeeding",
      value: "ການດູດນົມແມ່ທັນທີຫຼັງເກີດ",
    },
    {
      key: "Vitamin-A supplementation for children aged 6-59 months",
      value: "ການເສີມວິຕາມິນອາ ໃນເດັກອາຍຸ 6 - 59 ເດືອນ",
    },
    {
      key: "Deworming for children aged 12-59 months",
      value: "ການຂ້າແມ່ທ້ອງໃນເດັກອາຍຸ 12 - 59 ເດືອນ",
    },
    {
      key: "# Children with SAM identified",
      value: "# ເດັກນ້ອຍທີ່ມີອາການຮ້າຍແຮງ ຫລື SAM",
    },
    { key: "Province", value: "ແຂວງ" },
    { key: "Completeness", value: "ຄວາມສົມບູນ" },
    { key: "Timeliness", value: "ຄວາມທັນເວລາ" },
    { key: "Correctness", value: "ຄວາມຖືກຕ້ອງ" },
    { key: "Consistency", value: "ຄວາມສອດຄ່ອງ" },
    { key: "Overall data quality", value: "ຄຸນນະພາບໂດຍລວມຂອງຂໍ້ມູນ" },

    { key: "per", value: "ຕໍ່" },
    { key: "provinces", value: "Provinces" },
    { key: "buletin", value: "buletin LAOS" },
    { key: "staff", value: "Staff" },
    { key: "accessAndInfrastructure", value: "ການເຂົ້າເຖິງແລະພື້ນຖານໂຄງຮ່າງ" },
    { key: "services", value: "ການບໍລິການ" },
    {
      key: "noOfFacilitiesByOwnershipTypes",
      value: "Number of facilities by ownership types",
    },
    {
      key: "noOfFacilitiesByCategories",
      value: "Number of facilities by categories",
    },
    { key: "noOfFacilitiesByTypes", value: "Number of facilities by types" },
    { key: "noOfFacilitiesByStatus", value: "Number of facilities by status" },
    { key: "indicators", value: "ຕົວຊີ້ບອກທີ່ສໍາຄັນ" },
    {
      key: "topSectionWidget1Title",
      value: "ໜ່ວຍໃຫ້ບໍລິການທັງໝົດທີ່ຍັງໃຫ້ບໍລິການຢູ່",
    },
    {
      key: "topSectionWidget2Title",
      value: "ໂຮງໝໍນ້ອຍທີ່ມີອຸປະກອນທັງໝົດສໍາລັບການບໍລິການສຸຂະພາບທີ່ຈໍາເປັນ",
    },
    {
      key: "topSectionWidget3Title",
      value: "ໂຮງໝໍນ້ອຍທີ່ມີຢາທີ່ຈໍາເປັນ 80% ສໍາລັບການບໍລິການສຸຂະພາບທີ່ຈໍາເປັນ",
    },
    { key: "topSectionWidget4Title", value: "Total administrative units" },
    { key: "topSectionWidget5Title", value: "Total departments/offices" },
    {
      key: "topSectionWidget6Title",
      value: "ອັດ​ຕາ​ສ່ວນໂຮງ​ຫມໍຕໍ່​​​ປະ​ຊາ​ກອນ",
    },
    {
      key: "topSectionWidget7Title",
      value: "ອັດຕາສ່ວນໂຮງໝໍນ້ອຍຕໍ່ປະຊາກອນ",
    },
    { key: "topSectionWidget8Title", value: "ອັດຕາສ່ວນທ່ານໝໍຕໍ່ປະຊາກອນ" },
    { key: "topSectionWidget9Title", value: "ອັດຕາສ່ວນຂອງພະຍາບານຕໍ່ປະຊາກອນ" },
    { key: "serviceDeliUnitsWidget1Title", value: "ຜູ້ເປັນເຈົ້າຂອງ" },
    { key: "serviceDeliUnitsWidget2Title", value: "ອີງຕາມສະຖານທີ່" },
    {
      key: "serviceDeliUnitsWidget3Title",
      value: "ໂຮງໝໍນ້ອຍທີ່ມີການຄຸ້ມຄອງຊັບພະຍາກອນມະນຸດຢ່າງພຽງພໍ (>80%)",
    },
    {
      key: "serviceDeliUnitsWidget4Title",
      value: "ໂຮງໝໍນ້ອຍທີ່ມີໂຄງສ້າງພື້ນຖານໂຄງລ່າງທີ່ພຽງພໍ (>80%)",
    },
    { key: "serviceDeliUnitsWidget5Title", value: "ປະເພດໜ່ວຍງານ" },
    {
      key: "serviceDeliUnitsWidget7ChartTitle",
      value: "ສັດສ່ວນໂຮງໝໍຕໍ່ປະຊາກອນ",
    },
    {
      key: "serviceDeliUnitsWidget7ChartTitle2",
      value: "ສັດສ່ວນໂຮງໝໍນ້ອຍຕໍ່ປະຊາກອນ",
    },
    {
      key: "serviceDeliUnitsWidget6Title",
      value: "ໂຮງໝໍ ແລະ ໂຮງໝໍນ້ອຍ ແລະ ອັດຕາສ່ວນປະຊາກອນ (10,000)",
    },
    {
      key: "serviceDeliUnitsWidget7Title",
      value: "ໂຮງໝໍນ້ອຍພ້ອມກັບອຸປະກອນຂອງການບໍລິການສຸຂະພາບທີ່ຈໍາເປັນ",
    },
    {
      key: "serviceDeliUnitsWidget8ChartTitle",
      value: "ໂຮງໝໍນ້ອຍບໍ່ມີອຸປະກອນພຽງພໍສຳລັບການບໍລິການສຸຂະພາບທີ່ຈໍາເປັນ",
    },
    {
      key: "serviceDeliUnitsWidget8ChartTitle2",
      value: "ໂຮງໝໍນ້ອຍທີ່ອຸປະກອນທຸກຢ່າງສຳລັບການບໍລິການສຸຂະພາບທີ່ຈໍາເປັນ",
    },
    {
      key: "serviceDeliUnitsWidget8ChartTitle3",
      value: "ຍັງບໍ່ທັນໄດ້ເຮັດການສຳຫຼວດ",
    },
    {
      key: "accessAndInfrastructureWidget1Title",
      value:
        "ຈໍານວນສະຖານທີ່ໃຫ້ບໍລິການສາທາລະນະສຸກຕາມປະເພດຂອງເສັ້ນທາງເຂົ້າເຖິງແຕ່ລະແຂວງ",
    },
    {
      key: "accessAndInfrastructureWidget1ChartTitle",
      value: "ຈຳນວນສະຖານທີ່ບໍລິການແຍກຕາມປະເພດຂອງຫົນທາງ",
    },
    {
      key: "accessAndInfrastructureWidget2Title",
      value: "ຈໍານວນສະຖານທີ່ໃຫ້ບໍລິການສາທາລະນະສຸກໂດຍແຫຼ່ງໄຟຟ້າແຕ່ລະແຂວງ",
    },
    {
      key: "accessAndInfrastructureWidget2ChartTitle",
      value: "ຈຳນວນສະຖານທີ່ບໍລິການແຍກຕາມປະເພດຂອງແຫຼ່ງໄຟຟ້າ",
    },
    {
      key: "accessAndInfrastructureWidget3Title",
      value: "ຈຳນວນທັງມົດຂອງ ຕຽງນອນ, ຕູ້ເຢັນ, ລົດຈັກ, ລົດໃຫຍ່, ລົດສຸກເສີນ",
    },
    {
      key: "staffWidget1Title",
      value:
        "ທ່ານໝໍ, ແພດຜະດຸງຄັນ, ພະຍາບານ, (ພະນັກງານ ->; ຈຳນວນທັງໝົດ, ປົກກະຕິ, ອາສາສະໝັກ, ສັນຍາຈ້າງ)",
    },
    {
      key: "staffWidget2Title",
      value: "Doc ratio to population, nurse ratio to population",
    },
    {
      key: "servicesWidget1Title",
      value: "Total facility providing Advance surgery, Basic surgery",
    },
    {
      key: "servicesWidget2Title",
      value: "Total health centre, Health centre",
    },
    { key: "servicesWidget1ChartTitle", value: "" },
    { key: "Total Bed", value: "ຈຳນວນຕຽງທັງໝົດ" },
    { key: "Vaccine Fridge Total", value: "ຈຳນວນຕູ້ເຢັນທັງໝົດ" },
    { key: "Number of Bike", value: "ຈຳນວນລົດຈັກທັງໝົດ" },
    { key: "Number of Car", value: "ຈຳນວນລົົດໃຫຍ່ທັງໝົດ" },
    {
      key: "Number of Ambulance",
      value: "ຈຳນວນລົດສຸກເສີນທັງໝົດ",
    },
    { key: "OU_Facility Type", value: "ປະເພດຂອງສະຖານທີ່ບໍລິການ" },
  ],
};

export default locales;
